import { render, staticRenderFns } from "./ProductInfo.vue?vue&type=template&id=cb2f8394&"
import script from "./ProductInfo.vue?vue&type=script&lang=ts&"
export * from "./ProductInfo.vue?vue&type=script&lang=ts&"
import style0 from "./ProductInfo.vue?vue&type=style&index=0&id=cb2f8394&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports